import { render } from "./GullyONBookingInvoice.vue?vue&type=template&id=493b620c&scoped=true"
import script from "./GullyONBookingInvoice.vue?vue&type=script&lang=js"
export * from "./GullyONBookingInvoice.vue?vue&type=script&lang=js"

import "./GullyONBookingInvoice.vue?vue&type=style&index=0&id=493b620c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493b620c"]])

export default __exports__